var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { attrs: { id: "alert-filters-app" } },
    [
      _c("v-container", { staticClass: "alert-filter-container" }, [
        _c(
          "div",
          [
            _c("table", [
              _c("tr", { staticClass: "field-label" }, [
                _vm.currentBreakdowns.status
                  ? _c("td", [
                      _c("span", { staticClass: "field-label" }, [
                        _vm._v("Status"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentBreakdowns.enabled
                  ? _c("td", [
                      _c("span", { staticClass: "field-label" }, [
                        _vm._v("Enabled"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentBreakdowns.type && _vm.internalUserOrEventsOptIn
                  ? _c("td", [
                      _c("span", { staticClass: "field-label" }, [
                        _vm._v("Type"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentBreakdowns.cdr
                  ? _c("td", [
                      _c("span", { staticClass: "field-label" }, [
                        _vm._v("Metric"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentBreakdowns.createdBy
                  ? _c("td", [
                      _c("span", { staticClass: "field-label" }, [
                        _vm._v("Created By"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showButton ? _c("td") : _vm._e(),
              ]),
              _vm._v(" "),
              _c("tr", [
                _vm.currentBreakdowns.status
                  ? _c(
                      "td",
                      [
                        _c(
                          "v-btn-toggle",
                          {
                            staticClass: "mr-8",
                            attrs: { multiple: "" },
                            model: {
                              value: _vm.statusSelections,
                              callback: function ($$v) {
                                _vm.statusSelections = $$v
                              },
                              expression: "statusSelections",
                            },
                          },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  "content-class": "alert-state-tt",
                                  color: "var(--bad-color)",
                                  "nudge-bottom": "-1",
                                  bottom: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "selection-button",
                                                attrs: {
                                                  value: "Critical",
                                                  ripple: false,
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "alert-state-error",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-exclamation-triangle fa-fw",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currentBreakdowns
                                                          .status.Critical
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2310160368
                                ),
                              },
                              [_vm._v(" "), _c("span", [_vm._v("Critical")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  "content-class": "alert-state-tt",
                                  color: "var(--fair-color)",
                                  "nudge-bottom": "-1",
                                  bottom: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "selection-button",
                                                attrs: {
                                                  value: "Warn",
                                                  ripple: false,
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "alert-state-warn",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-exclamation-square fa-fw",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currentBreakdowns
                                                          .status.Warn
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  551141869
                                ),
                              },
                              [_vm._v(" "), _c("span", [_vm._v("Warn")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  "content-class": "alert-state-tt",
                                  color: "#0073b7",
                                  "nudge-bottom": "-1",
                                  bottom: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "selection-button",
                                                attrs: {
                                                  value: "Info",
                                                  ripple: false,
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "alert-state-info",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-info-circle fa-fw",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currentBreakdowns
                                                          .status.Info
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3758152407
                                ),
                              },
                              [_vm._v(" "), _c("span", [_vm._v("Info")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  "content-class": "alert-state-tt",
                                  color: "var(--good-color)",
                                  "nudge-bottom": "-1",
                                  bottom: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "selection-button",
                                                attrs: {
                                                  value: "Clear",
                                                  ripple: false,
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "alert-state-ok",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-check-circle fa-fw",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currentBreakdowns
                                                          .status.Clear
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1081192373
                                ),
                              },
                              [_vm._v(" "), _c("span", [_vm._v("Clear")])]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentBreakdowns.enabled
                  ? _c(
                      "td",
                      [
                        _c(
                          "v-btn-toggle",
                          {
                            staticClass: "mr-8",
                            model: {
                              value: _vm.enabledSelection,
                              callback: function ($$v) {
                                _vm.enabledSelection = $$v
                              },
                              expression: "enabledSelection",
                            },
                          },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  color: "var(--tooltip-background)",
                                  "nudge-bottom": "-1",
                                  bottom: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "selection-button",
                                                attrs: {
                                                  value: "false",
                                                  ripple: false,
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "far fa-toggle-large-on fa-flip-horizontal fa-fw toggle-off-icon",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.currentBreakdowns
                                                        .enabled.no
                                                    )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2281018633
                                ),
                              },
                              [_vm._v(" "), _c("span", [_vm._v("Disabled")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  color: "var(--tooltip-background)",
                                  "nudge-bottom": "-1",
                                  bottom: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "selection-button",
                                                attrs: {
                                                  value: "true",
                                                  ripple: false,
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "far fa-toggle-large-on fa-fw toggle-on-icon",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.currentBreakdowns
                                                        .enabled.yes
                                                    )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3089666664
                                ),
                              },
                              [_vm._v(" "), _c("span", [_vm._v("Enabled")])]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentBreakdowns.type && _vm.internalUserOrEventsOptIn
                  ? _c(
                      "td",
                      [
                        _c(
                          "v-btn-toggle",
                          {
                            staticClass: "mr-8",
                            model: {
                              value: _vm.typeSelection,
                              callback: function ($$v) {
                                _vm.typeSelection = $$v
                              },
                              expression: "typeSelection",
                            },
                          },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  color: "var(--tooltip-background)",
                                  "nudge-bottom": "-1",
                                  bottom: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "selection-button",
                                                attrs: {
                                                  value: "metrics",
                                                  ripple: false,
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "far fa-chart-line fa-fw",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.currentBreakdowns.type
                                                        .metric
                                                    )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1199735942
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("span", [_vm._v("Metric Monitors")]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  color: "var(--tooltip-background)",
                                  "nudge-bottom": "-1",
                                  bottom: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "selection-button",
                                                attrs: {
                                                  value: "events",
                                                  ripple: false,
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "far fa-rectangle-list fa-fw",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.currentBreakdowns.type
                                                        .event
                                                    )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1985998087
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("span", [_vm._v("Event Monitors")]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentBreakdowns.cdr
                  ? _c(
                      "td",
                      [
                        _c(
                          "v-btn-toggle",
                          {
                            staticClass: "mr-8",
                            model: {
                              value: _vm.cdrSelection,
                              callback: function ($$v) {
                                _vm.cdrSelection = $$v
                              },
                              expression: "cdrSelection",
                            },
                          },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  color: "var(--tooltip-background)",
                                  "nudge-bottom": "-1",
                                  bottom: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "selection-button",
                                                attrs: {
                                                  value: "false",
                                                  ripple: false,
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-water fa-fw",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.currentBreakdowns.cdr
                                                        .no
                                                    )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1981065055
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("span", [_vm._v("Realtime Stream")]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  color: "var(--tooltip-background)",
                                  "nudge-bottom": "-1",
                                  bottom: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "selection-button",
                                                attrs: {
                                                  value: "true",
                                                  ripple: false,
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "far fa-hourglass-half fa-fw",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.currentBreakdowns.cdr
                                                        .yes
                                                    )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2147212746
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("span", [_vm._v("Call Records")]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentBreakdowns.createdBy
                  ? _c(
                      "td",
                      [
                        _c(
                          "v-btn-toggle",
                          {
                            staticClass: "mr-8",
                            model: {
                              value: _vm.createdBySelection,
                              callback: function ($$v) {
                                _vm.createdBySelection = $$v
                              },
                              expression: "createdBySelection",
                            },
                          },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  color: "var(--tooltip-background)",
                                  "nudge-bottom": "-1",
                                  bottom: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "selection-button",
                                                attrs: {
                                                  value: "me",
                                                  ripple: false,
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-user fa-fw",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.currentBreakdowns
                                                        .createdBy.me
                                                    )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  693542089
                                ),
                              },
                              [_vm._v(" "), _c("span", [_vm._v("Me")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  color: "var(--tooltip-background)",
                                  "nudge-bottom": "-1",
                                  bottom: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "selection-button",
                                                attrs: {
                                                  value: "others",
                                                  ripple: false,
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-users fa-fw",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.currentBreakdowns
                                                        .createdBy.others
                                                    )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2122039130
                                ),
                              },
                              [_vm._v(" "), _c("span", [_vm._v("Others")])]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showButton
                  ? _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "add-monitor-btn btn btn-primary",
                          attrs: { color: "#024ad8", depressed: "" },
                          on: { click: (event) => _vm.showAddMoi(event) },
                        },
                        [
                          _c("span", { staticClass: "add-monitor-text" }, [
                            _vm._v("Add Monitor"),
                          ]),
                          _vm.internalUserOrEventsOptIn
                            ? _c(
                                "v-icon",
                                {
                                  staticClass: "add-monitor-btn-icon",
                                  attrs: { "x-small": "" },
                                },
                                [_vm._v("fas fa-chevron-down")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showAddMoiMenu
                            ? _c(
                                "div",
                                { staticClass: "monitorTypeSelect" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "add-monitor-menu-section",
                                      class: { monitor: true, selected: false },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addMoi("metric")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "far fa-chart-line add-monitor-icon",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "add-monitor-menu-subsection",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "add-monitor-header",
                                            },
                                            [_vm._v("Metric Monitor")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "add-monitor-description",
                                            },
                                            [
                                              _vm._v(
                                                "Compare metric values against thresholds."
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "add-monitor-menu-section",
                                      class: { monitor: true, selected: false },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addMoi("event")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "far fa-rectangle-list add-monitor-icon",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "add-monitor-menu-subsection",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "add-monitor-header",
                                            },
                                            [
                                              _vm._v("Event Monitor "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "new-beta badge",
                                                },
                                                [_vm._v("beta")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "add-monitor-description",
                                            },
                                            [
                                              _vm._v(
                                                "Monitor when events occur."
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "monitorTypeSupport" },
                                    [
                                      _vm._v(
                                        "\n                        Read our "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            target: "_blank",
                                            href: _vm.brandingService.getSupportUrl(
                                              "monitorTypes"
                                            ),
                                          },
                                        },
                                        [_vm._v("support article")]
                                      ),
                                      _vm._v(" on the monitor types"),
                                      _c("br"),
                                      _vm._v(
                                        "\n                        with details and examples.\n                    "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("v-spacer"),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }